<div class="tabs-container padding-bottom">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Not Submitted">
            <ag-grid-angular class="data-grid " [rowData]="unsubmitted" [gridOptions]="notSubmittedGridOptions" [attr.aria-label]="widgetTitle + ' - Not Submitted'"></ag-grid-angular>
        </tab>
        <tab title="Returned">
            <ag-grid-angular class="data-grid " [rowData]="returned" [gridOptions]="returnedGridOptions" [attr.aria-label]="widgetTitle + ' - Returned'"></ag-grid-angular>
        </tab>
        <tab title="Ejected">
            <ag-grid-angular class="data-grid " [rowData]="incompletes" [gridOptions]="incompleteGridOptions" [attr.aria-label]="widgetTitle + ' - Ejected'"></ag-grid-angular>
        </tab>
        <tab title="Submitted">
            <ag-grid-angular class="data-grid " [rowData]="reviews" [gridOptions]="reviewGridOptions" [attr.aria-label]="widgetTitle + ' - Submitted'"></ag-grid-angular>
        </tab>
    </tabs>
</div>
